<template>
  <span class="custom-sort caret-wrapper" @click.stop="sortFun">
    <i v-if="allowAsc" :class="{ 'sort-caret': true, ascending: true, active: currentType === 'asc' }"></i>
    <i v-if="allowDesc" :class="{ 'sort-caret': true, descending: true, active: currentType === 'desc' }"></i>
  </span>
</template>
<script>
export default {
  props: {
    isSingle: {
      //是否是单项排序
      type: Boolean,
      default: true
    },
    codeName: {
      type: String,
      default: ""
    },
    currentCode: {
      type: String,
      default: ""
    },
    /** 后端 orders：asc=升序、desc=降序；只保留已配置方向 */
    orders: {
      type: Array,
      default: () => ["asc", "desc"]
    }
  },
  watch: {
    currentCode(newV) {
      if (newV !== this.codeName) {
        this.currentType = "";
      }
    },
    orders: {
      handler() {
        // 当前方向不在可用列表时回退为空
        if (this.currentType && !this.allowedTypes.includes(this.currentType)) {
          this.currentType = "";
        }
      },
      deep: true
    }
  },
  data() {
    return {
      /** "" | "asc" | "desc" */
      currentType: ""
    };
  },
  computed: {
    /** 固定语义：asc 升序、desc 降序；仅保留 orders 中配置的项 */
    allowedTypes() {
      const list = Array.isArray(this.orders) ? this.orders : [];
      const next = [];
      if (list.indexOf("asc") > -1) next.push("asc");
      if (list.indexOf("desc") > -1) next.push("desc");
      return next.length ? next : ["asc", "desc"];
    },
    allowAsc() {
      return this.allowedTypes.indexOf("asc") > -1;
    },
    allowDesc() {
      return this.allowedTypes.indexOf("desc") > -1;
    },
    /** 点击循环：空 → 已配置升序 → 已配置降序 → 空 */
    cycleTypes() {
      return ["", ...this.allowedTypes];
    }
  },
  methods: {
    sortFun() {
      const cycle = this.cycleTypes;
      let idx = cycle.indexOf(this.currentType);
      if (idx < 0) idx = 0;
      idx = (idx + 1) % cycle.length;
      this.currentType = cycle[idx];
      this.$emit("changeSort", this.currentType);
    }
  }
};
</script>
<style lang="scss" scoped>
.caret-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  height: 34px;
  width: 24px;
  vertical-align: middle;
  cursor: pointer;
  overflow: initial;
  position: relative;
}
.sort-caret.ascending {
  border-bottom-color: #c0c4cc;
  top: 5px;
}
.sort-caret.descending {
  border-top-color: #c0c4cc;
  bottom: 7px;
}
.active.ascending {
  border-bottom-color: var(--color-primary);
}
.active.descending {
  border-top-color: var(--color-primary);
}
.sort-caret {
  width: 0;
  height: 0;
  border: 5px solid transparent;
  position: absolute;
  left: 7px;
}
</style>
